// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { CommonAiSuggestion_WithKgv2Fragment } from './aiSuggestions.fragments.generated';
import { gql } from '@apollo/client';
import { CommonAiSuggestion_WithKgv2FragmentDoc } from './aiSuggestions.fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CommonAiSuggestionActor_InferredBeneficialOwnerDetails_Fragment = { __typename?: 'InferredBeneficialOwnerDetails', firstName?: string | null, lastName?: string | null, middleName?: string | null, organizationName?: string | null, suffix?: string | null, existingID?: string | null, referenceAIOnboardingSuggestionID?: string | null };

export type CommonAiSuggestionActor_InferredBeneficiaryDetails_Fragment = { __typename?: 'InferredBeneficiaryDetails', firstName?: string | null, lastName?: string | null, middleName?: string | null, organizationName?: string | null, suffix?: string | null, existingID?: string | null, referenceAIOnboardingSuggestionID?: string | null };

export type CommonAiSuggestionActor_InferredBeneficiaryDetailsV2_Fragment = { __typename?: 'InferredBeneficiaryDetailsV2', firstName?: string | null, lastName?: string | null, middleName?: string | null, organizationName?: string | null, suffix?: string | null, existingID?: string | null, referenceAIOnboardingSuggestionID?: string | null };

export type CommonAiSuggestionActor_InferredGrantorDetails_Fragment = { __typename?: 'InferredGrantorDetails', firstName?: string | null, lastName?: string | null, middleName?: string | null, organizationName?: string | null, suffix?: string | null, existingID?: string | null, referenceAIOnboardingSuggestionID?: string | null };

export type CommonAiSuggestionActor_InferredKeyPersonDetails_Fragment = { __typename?: 'InferredKeyPersonDetails', firstName?: string | null, lastName?: string | null, middleName?: string | null, organizationName?: string | null, suffix?: string | null, existingID?: string | null, referenceAIOnboardingSuggestionID?: string | null };

export type CommonAiSuggestionActor_InferredTrustAdvisorDetails_Fragment = { __typename?: 'InferredTrustAdvisorDetails', firstName?: string | null, lastName?: string | null, middleName?: string | null, organizationName?: string | null, suffix?: string | null, existingID?: string | null, referenceAIOnboardingSuggestionID?: string | null };

export type CommonAiSuggestionActor_InferredTrusteeDetails_Fragment = { __typename?: 'InferredTrusteeDetails', firstName?: string | null, lastName?: string | null, middleName?: string | null, organizationName?: string | null, suffix?: string | null, existingID?: string | null, referenceAIOnboardingSuggestionID?: string | null };

export type CommonAiSuggestionActorFragment = CommonAiSuggestionActor_InferredBeneficialOwnerDetails_Fragment | CommonAiSuggestionActor_InferredBeneficiaryDetails_Fragment | CommonAiSuggestionActor_InferredBeneficiaryDetailsV2_Fragment | CommonAiSuggestionActor_InferredGrantorDetails_Fragment | CommonAiSuggestionActor_InferredKeyPersonDetails_Fragment | CommonAiSuggestionActor_InferredTrustAdvisorDetails_Fragment | CommonAiSuggestionActor_InferredTrusteeDetails_Fragment;

export type ReferenceAiOnboardingSuggestionFragment = { __typename?: 'AISuggestion', id: string, kind: Types.AiSuggestionKind, onboardedIndividual?: { __typename?: 'ClientProfile', id: string } | null, onboardedOrganization?: { __typename?: 'ClientOrganization', id: string } | null, onboardedEntity?: { __typename?: 'Entity', id: string } | null, onboardedTestamentaryEntity?: { __typename?: 'TestamentaryEntity', id: string } | null };

export type CommonAiSuggestionEvidenceFragment = { __typename?: 'AISuggestionEvidence', id: string, fileParagraphs: { __typename?: 'FileParagraphConnection', edges?: Array<{ __typename?: 'FileParagraphEdge', node?: { __typename?: 'FileParagraph', id: string, boundingRegions: Array<{ __typename?: 'BoundingRegion', PageNumber: number, Polygon: Array<{ __typename?: 'Coordinate', x: number, y: number }> }>, file?: { __typename?: 'File', id: string, pdfDocument?: { __typename?: 'Document', id: string, type: Types.DocumentType } | null } | null } | null } | null> | null } };

export type BeneficiaryAccessParameterFragment = { __typename?: 'InferredBeneficiaryAccessParameterDetails', kind?: Types.AccessParameterKind | null, distributionAmount?: string | null, distributionPercentage?: string | null, distributionFrequency?: Types.AccessParameterFrequency | null, accessAgeParameters?: (
    { __typename?: 'InferredAccessAgeParameterDetails' }
    & BeneficiaryAgeParametersFragment
  ) | null };

export type BeneficiaryScheduledDistributionFragment = { __typename?: 'InferredScheduledDistributionDetails', kind?: Types.ScheduledDistributionKind | null, distributionAmount?: string | null, distributionPercentage?: string | null, distributionFrequency?: Types.ScheduledDistributionFrequency | null, notes?: string | null, accessAgeParameters?: (
    { __typename?: 'InferredAccessAgeParameterDetails' }
    & BeneficiaryAgeParametersFragment
  ) | null };

export type BeneficiaryAgeParametersFragment = { __typename?: 'InferredAccessAgeParameterDetails', ageRequirementStart?: number | null, ageRequirementEnd?: number | null, notes?: string | null };

export type BeneficiaryV2AiSuggestionFragment = { __typename?: 'AISuggestion', id: string, beneficiaryV2?: (
    { __typename?: 'InferredBeneficiaryDetailsV2', order?: Types.BeneficiaryLevel | null, powerOfAppointment?: Types.BeneficiaryPowerOfAppointmentPower | null, powerOfAppointmentNotes?: string | null, notes?: string | null, accessParameters?: Array<(
      { __typename?: 'InferredBeneficiaryAccessParameterDetails' }
      & BeneficiaryAccessParameterFragment
    ) | null> | null, scheduledDistributions?: Array<(
      { __typename?: 'InferredScheduledDistributionDetails' }
      & BeneficiaryScheduledDistributionFragment
    ) | null> | null }
    & CommonAiSuggestionActor_InferredBeneficiaryDetailsV2_Fragment
  ) | null };

export type SubtrustBeneficiaryAiSuggestionFragment = { __typename?: 'AISuggestion', id: string, subtrustLifetimeBeneficiary?: (
    { __typename?: 'InferredBeneficiaryDetailsV2', beneficiaryKind?: Types.BeneficiaryKind | null, order?: Types.BeneficiaryLevel | null, powerOfAppointment?: Types.BeneficiaryPowerOfAppointmentPower | null, powerOfAppointmentNotes?: string | null, notes?: string | null, accessParameters?: Array<(
      { __typename?: 'InferredBeneficiaryAccessParameterDetails' }
      & BeneficiaryAccessParameterFragment
    ) | null> | null, scheduledDistributions?: Array<(
      { __typename?: 'InferredScheduledDistributionDetails' }
      & BeneficiaryScheduledDistributionFragment
    ) | null> | null }
    & CommonAiSuggestionActor_InferredBeneficiaryDetailsV2_Fragment
  ) | null, subtrustRemainderBeneficiary?: (
    { __typename?: 'InferredBeneficiaryDetailsV2', beneficiaryKind?: Types.BeneficiaryKind | null, order?: Types.BeneficiaryLevel | null, powerOfAppointment?: Types.BeneficiaryPowerOfAppointmentPower | null, powerOfAppointmentNotes?: string | null, notes?: string | null, accessParameters?: Array<(
      { __typename?: 'InferredBeneficiaryAccessParameterDetails' }
      & BeneficiaryAccessParameterFragment
    ) | null> | null, scheduledDistributions?: Array<(
      { __typename?: 'InferredScheduledDistributionDetails' }
      & BeneficiaryScheduledDistributionFragment
    ) | null> | null }
    & CommonAiSuggestionActor_InferredBeneficiaryDetailsV2_Fragment
  ) | null };

export type SubtrustTrusteeAiSuggestionFragment = { __typename?: 'AISuggestion', id: string, subtrustTrustee?: (
    { __typename?: 'InferredTrusteeDetails', order?: Types.TrusteeLevel | null, duties: Array<Types.TrusteeDutyKind> }
    & CommonAiSuggestionActor_InferredTrusteeDetails_Fragment
  ) | null, subtrustSuccessorTrustee?: (
    { __typename?: 'InferredTrusteeDetails', order?: Types.TrusteeLevel | null, duties: Array<Types.TrusteeDutyKind> }
    & CommonAiSuggestionActor_InferredTrusteeDetails_Fragment
  ) | null, subtrustTrustAdvisor?: (
    { __typename?: 'InferredTrustAdvisorDetails', order: Types.TrustAdvisorLevel, roles: Array<Types.TrustAdvisorRoleKind> }
    & CommonAiSuggestionActor_InferredTrustAdvisorDetails_Fragment
  ) | null };

export type EntityDocumentRelationship_AiSuggestionFragment = { __typename?: 'EntityDocumentRelationship', id: string, relationshipType: Types.EntityDocumentRelationshipRelationshipType, suggestionPrecedenceOrder?: number | null, createdAt: Time, entity?: { __typename?: 'Entity', id: string } | null, document: { __typename?: 'Document', id: string, name: string, type: Types.DocumentType } };

export type CommonAiSuggestionFragment = (
  { __typename?: 'AISuggestion', id: string, kind: Types.AiSuggestionKind, acceptanceStatus?: Types.AiSuggestionAcceptanceStatus | null, effectiveDate?: Time | null, gstStatus?: Types.AiSuggestionEntityGstStatus | null, jurisdictionStateCode?: string | null, legalName?: string | null, crummeyWithdrawalPeriodDays?: number | null, doingBusinessAsName?: string | null, fincenID?: string | null, taxID?: string | null, businessEntityTaxStatus?: Types.AiSuggestionBusinessEntityTaxStatus | null, beneficialOwnersAsOfDate?: Time | null, subtrustType?: Types.AiSuggestionTestamentaryEntityKind | null, subtrustGstStatus?: Types.AiSuggestionEntityGstStatus | null, principal?: (
    { __typename?: 'InferredGrantorDetails' }
    & CommonAiSuggestionActor_InferredGrantorDetails_Fragment
  ) | null, trustee?: (
    { __typename?: 'InferredTrusteeDetails', order?: Types.TrusteeLevel | null, duties: Array<Types.TrusteeDutyKind> }
    & CommonAiSuggestionActor_InferredTrusteeDetails_Fragment
  ) | null, successorTrustee?: (
    { __typename?: 'InferredTrusteeDetails', order?: Types.TrusteeLevel | null, duties: Array<Types.TrusteeDutyKind> }
    & CommonAiSuggestionActor_InferredTrusteeDetails_Fragment
  ) | null, trustAdvisor?: (
    { __typename?: 'InferredTrustAdvisorDetails', order: Types.TrustAdvisorLevel, roles: Array<Types.TrustAdvisorRoleKind> }
    & CommonAiSuggestionActor_InferredTrustAdvisorDetails_Fragment
  ) | null, beneficiary?: (
    { __typename?: 'InferredBeneficiaryDetails', distributionAmount?: string | null, distributionFrequency?: Types.BeneficiaryDistributionDistributionFrequency | null, distributionPercentage?: string | null, order?: Types.BeneficiaryLevel | null, notes?: string | null }
    & CommonAiSuggestionActor_InferredBeneficiaryDetails_Fragment
  ) | null, subtrustCreatedFrom?: { __typename?: 'InferredSubtrustCreatedFromDetails', displayName?: string | null, type?: Types.SubtrustCreatedFromType | null } | null, beneficialOwner?: (
    { __typename?: 'InferredBeneficialOwnerDetails', percentage?: string | null }
    & CommonAiSuggestionActor_InferredBeneficialOwnerDetails_Fragment
  ) | null, keyPerson?: (
    { __typename?: 'InferredKeyPersonDetails', roles: Array<Types.KeyPersonRoleKind> }
    & CommonAiSuggestionActor_InferredKeyPersonDetails_Fragment
  ) | null, clientOrganization?: { __typename?: 'ClientOrganization', id: string } | null, clientProfile?: { __typename?: 'ClientProfile', id: string } | null, entity?: { __typename?: 'Entity', id: string, entityDocumentRelationships: { __typename?: 'EntityDocumentRelationshipConnection', edges?: Array<{ __typename?: 'EntityDocumentRelationshipEdge', node?: { __typename?: 'EntityDocumentRelationship', id: string, relationshipType: Types.EntityDocumentRelationshipRelationshipType, document: { __typename?: 'Document', id: string, type: Types.DocumentType } } | null } | null> | null } } | null, testamentaryEntity?: { __typename?: 'TestamentaryEntity', id: string, entityDocumentRelationships: { __typename?: 'EntityDocumentRelationshipConnection', edges?: Array<{ __typename?: 'EntityDocumentRelationshipEdge', node?: { __typename?: 'EntityDocumentRelationship', id: string, relationshipType: Types.EntityDocumentRelationshipRelationshipType, document: { __typename?: 'Document', id: string, type: Types.DocumentType } } | null } | null> | null } } | null, file?: { __typename?: 'File', id: string, document?: { __typename?: 'Document', id: string } | null } | null, evidence?: Array<(
    { __typename?: 'AISuggestionEvidence' }
    & CommonAiSuggestionEvidenceFragment
  )> | null, referenceAiOnboardingSuggestion?: (
    { __typename?: 'AISuggestion' }
    & ReferenceAiOnboardingSuggestionFragment
  ) | null }
  & BeneficiaryV2AiSuggestionFragment
  & SubtrustBeneficiaryAiSuggestionFragment
  & SubtrustTrusteeAiSuggestionFragment
  & CommonAiSuggestion_WithKgv2Fragment
);

export type FetchEntityAiSuggestionsQueryVariables = Types.Exact<{
  entityID: Types.Scalars['ID']['input'];
}>;


export type FetchEntityAiSuggestionsQuery = { __typename?: 'Query', suggestionsFromRelationships: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: (
        { __typename?: 'AISuggestion' }
        & CommonAiSuggestionFragment
      ) | null } | null> | null }, entityDocumentSourceRelationships: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, entityDocumentRelationships: { __typename?: 'EntityDocumentRelationshipConnection', edges?: Array<{ __typename?: 'EntityDocumentRelationshipEdge', node?: (
              { __typename?: 'EntityDocumentRelationship' }
              & EntityDocumentRelationship_AiSuggestionFragment
            ) | null } | null> | null } } | null } | null> | null } };

export type AcknowledgeAiSuggestionsMutationVariables = Types.Exact<{
  input: Array<Types.AcknowledgeAiSuggestionInput> | Types.AcknowledgeAiSuggestionInput;
}>;


export type AcknowledgeAiSuggestionsMutation = { __typename?: 'Mutation', acknowledgeAISuggestions: Array<{ __typename?: 'AISuggestion', id: string, acceptanceStatus?: Types.AiSuggestionAcceptanceStatus | null }> };

export const Operations = {
  Query: {
    FetchEntityAISuggestions: 'FetchEntityAISuggestions' as const
  },
  Mutation: {
    AcknowledgeAISuggestions: 'AcknowledgeAISuggestions' as const
  },
  Fragment: {
    CommonAISuggestionActor: 'CommonAISuggestionActor' as const,
    ReferenceAIOnboardingSuggestion: 'ReferenceAIOnboardingSuggestion' as const,
    CommonAISuggestionEvidence: 'CommonAISuggestionEvidence' as const,
    BeneficiaryAccessParameter: 'BeneficiaryAccessParameter' as const,
    BeneficiaryScheduledDistribution: 'BeneficiaryScheduledDistribution' as const,
    BeneficiaryAgeParameters: 'BeneficiaryAgeParameters' as const,
    BeneficiaryV2AISuggestion: 'BeneficiaryV2AISuggestion' as const,
    SubtrustBeneficiaryAISuggestion: 'SubtrustBeneficiaryAISuggestion' as const,
    SubtrustTrusteeAISuggestion: 'SubtrustTrusteeAISuggestion' as const,
    EntityDocumentRelationship_AISuggestion: 'EntityDocumentRelationship_AISuggestion' as const,
    CommonAISuggestion: 'CommonAISuggestion' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EntityDocumentRelationship_AiSuggestionFragmentDoc = gql`
    fragment EntityDocumentRelationship_AISuggestion on EntityDocumentRelationship {
  id
  relationshipType
  suggestionPrecedenceOrder
  createdAt
  entity {
    id
  }
  document {
    id
    name
    type
  }
}
    `;
export const CommonAiSuggestionActorFragmentDoc = gql`
    fragment CommonAISuggestionActor on InferredTrustActor {
  firstName
  lastName
  middleName
  organizationName
  suffix
  existingID
  referenceAIOnboardingSuggestionID
}
    `;
export const BeneficiaryAgeParametersFragmentDoc = gql`
    fragment BeneficiaryAgeParameters on InferredAccessAgeParameterDetails {
  ageRequirementStart
  ageRequirementEnd
  notes
}
    `;
export const BeneficiaryAccessParameterFragmentDoc = gql`
    fragment BeneficiaryAccessParameter on InferredBeneficiaryAccessParameterDetails {
  kind
  distributionAmount
  distributionPercentage
  distributionFrequency
  accessAgeParameters {
    ...BeneficiaryAgeParameters
  }
}
    ${BeneficiaryAgeParametersFragmentDoc}`;
export const BeneficiaryScheduledDistributionFragmentDoc = gql`
    fragment BeneficiaryScheduledDistribution on InferredScheduledDistributionDetails {
  kind
  distributionAmount
  distributionPercentage
  distributionFrequency
  accessAgeParameters {
    ...BeneficiaryAgeParameters
  }
  notes
}
    ${BeneficiaryAgeParametersFragmentDoc}`;
export const BeneficiaryV2AiSuggestionFragmentDoc = gql`
    fragment BeneficiaryV2AISuggestion on AISuggestion {
  id
  beneficiaryV2 {
    ...CommonAISuggestionActor
    order
    accessParameters {
      ...BeneficiaryAccessParameter
    }
    scheduledDistributions {
      ...BeneficiaryScheduledDistribution
    }
    powerOfAppointment
    powerOfAppointmentNotes
    notes
  }
}
    ${CommonAiSuggestionActorFragmentDoc}
${BeneficiaryAccessParameterFragmentDoc}
${BeneficiaryScheduledDistributionFragmentDoc}`;
export const SubtrustBeneficiaryAiSuggestionFragmentDoc = gql`
    fragment SubtrustBeneficiaryAISuggestion on AISuggestion {
  id
  subtrustLifetimeBeneficiary {
    ...CommonAISuggestionActor
    beneficiaryKind
    order
    accessParameters {
      ...BeneficiaryAccessParameter
    }
    scheduledDistributions {
      ...BeneficiaryScheduledDistribution
    }
    powerOfAppointment
    powerOfAppointmentNotes
    notes
  }
  subtrustRemainderBeneficiary {
    ...CommonAISuggestionActor
    beneficiaryKind
    order
    accessParameters {
      ...BeneficiaryAccessParameter
    }
    scheduledDistributions {
      ...BeneficiaryScheduledDistribution
    }
    powerOfAppointment
    powerOfAppointmentNotes
    notes
  }
}
    ${CommonAiSuggestionActorFragmentDoc}
${BeneficiaryAccessParameterFragmentDoc}
${BeneficiaryScheduledDistributionFragmentDoc}`;
export const SubtrustTrusteeAiSuggestionFragmentDoc = gql`
    fragment SubtrustTrusteeAISuggestion on AISuggestion {
  id
  subtrustTrustee {
    order
    duties
    ...CommonAISuggestionActor
  }
  subtrustSuccessorTrustee {
    order
    duties
    ...CommonAISuggestionActor
  }
  subtrustTrustAdvisor {
    order
    roles
    ...CommonAISuggestionActor
  }
}
    ${CommonAiSuggestionActorFragmentDoc}`;
export const CommonAiSuggestionEvidenceFragmentDoc = gql`
    fragment CommonAISuggestionEvidence on AISuggestionEvidence {
  id
  fileParagraphs {
    edges {
      node {
        id
        boundingRegions {
          PageNumber
          Polygon {
            x
            y
          }
        }
        file {
          id
          pdfDocument {
            id
            type
          }
        }
      }
    }
  }
}
    `;
export const ReferenceAiOnboardingSuggestionFragmentDoc = gql`
    fragment ReferenceAIOnboardingSuggestion on AISuggestion {
  id
  kind
  onboardedIndividual {
    id
  }
  onboardedOrganization {
    id
  }
  onboardedEntity {
    id
  }
  onboardedTestamentaryEntity {
    id
  }
}
    `;
export const CommonAiSuggestionFragmentDoc = gql`
    fragment CommonAISuggestion on AISuggestion {
  id
  kind
  acceptanceStatus
  effectiveDate
  gstStatus
  jurisdictionStateCode
  legalName
  crummeyWithdrawalPeriodDays
  doingBusinessAsName
  fincenID
  taxID
  businessEntityTaxStatus
  beneficialOwnersAsOfDate
  principal {
    ...CommonAISuggestionActor
  }
  trustee {
    order
    duties
    ...CommonAISuggestionActor
  }
  successorTrustee {
    order
    duties
    ...CommonAISuggestionActor
  }
  trustAdvisor {
    order
    roles
    ...CommonAISuggestionActor
  }
  beneficiary {
    distributionAmount
    distributionFrequency
    distributionPercentage
    order
    notes
    ...CommonAISuggestionActor
  }
  ...BeneficiaryV2AISuggestion
  ...SubtrustBeneficiaryAISuggestion
  ...SubtrustTrusteeAISuggestion
  subtrustType
  subtrustGstStatus
  subtrustCreatedFrom {
    displayName
    type
  }
  beneficialOwner {
    percentage
    ...CommonAISuggestionActor
  }
  keyPerson {
    roles
    ...CommonAISuggestionActor
  }
  clientOrganization {
    id
  }
  clientProfile {
    id
  }
  entity {
    id
    entityDocumentRelationships {
      edges {
        node {
          id
          relationshipType
          document {
            id
            type
          }
        }
      }
    }
  }
  testamentaryEntity {
    id
    entityDocumentRelationships {
      edges {
        node {
          id
          relationshipType
          document {
            id
            type
          }
        }
      }
    }
  }
  file {
    id
    document {
      id
    }
  }
  evidence {
    ...CommonAISuggestionEvidence
  }
  referenceAiOnboardingSuggestion {
    ...ReferenceAIOnboardingSuggestion
  }
  ...CommonAISuggestion_WithKGV2
}
    ${CommonAiSuggestionActorFragmentDoc}
${BeneficiaryV2AiSuggestionFragmentDoc}
${SubtrustBeneficiaryAiSuggestionFragmentDoc}
${SubtrustTrusteeAiSuggestionFragmentDoc}
${CommonAiSuggestionEvidenceFragmentDoc}
${ReferenceAiOnboardingSuggestionFragmentDoc}
${CommonAiSuggestion_WithKgv2FragmentDoc}`;
export const FetchEntityAiSuggestionsDocument = gql`
    query FetchEntityAISuggestions($entityID: ID!) {
  suggestionsFromRelationships: aiSuggestions(
    where: {hasFileWith: {hasDocumentWith: {hasEntityDocumentRelationshipsWith: {relationshipType: SOURCE_DOCUMENT, hasEntityWith: {id: $entityID}}}}, hasEntityWith: {id: $entityID}}
  ) {
    edges {
      node {
        ...CommonAISuggestion
      }
    }
  }
  entityDocumentSourceRelationships: entities(where: {id: $entityID}) {
    edges {
      node {
        id
        entityDocumentRelationships(where: {relationshipType: SOURCE_DOCUMENT}) {
          edges {
            node {
              ...EntityDocumentRelationship_AISuggestion
            }
          }
        }
      }
    }
  }
}
    ${CommonAiSuggestionFragmentDoc}
${EntityDocumentRelationship_AiSuggestionFragmentDoc}`;

/**
 * __useFetchEntityAiSuggestionsQuery__
 *
 * To run a query within a React component, call `useFetchEntityAiSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEntityAiSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEntityAiSuggestionsQuery({
 *   variables: {
 *      entityID: // value for 'entityID'
 *   },
 * });
 */
export function useFetchEntityAiSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<FetchEntityAiSuggestionsQuery, FetchEntityAiSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchEntityAiSuggestionsQuery, FetchEntityAiSuggestionsQueryVariables>(FetchEntityAiSuggestionsDocument, withFetchPolicyContext(options));
      }
export function useFetchEntityAiSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchEntityAiSuggestionsQuery, FetchEntityAiSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchEntityAiSuggestionsQuery, FetchEntityAiSuggestionsQueryVariables>(FetchEntityAiSuggestionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFetchEntityAiSuggestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchEntityAiSuggestionsQuery, FetchEntityAiSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchEntityAiSuggestionsQuery, FetchEntityAiSuggestionsQueryVariables>(FetchEntityAiSuggestionsDocument, withFetchPolicyContext(options));
        }
export type FetchEntityAiSuggestionsQueryHookResult = ReturnType<typeof useFetchEntityAiSuggestionsQuery>;
export type FetchEntityAiSuggestionsLazyQueryHookResult = ReturnType<typeof useFetchEntityAiSuggestionsLazyQuery>;
export type FetchEntityAiSuggestionsSuspenseQueryHookResult = ReturnType<typeof useFetchEntityAiSuggestionsSuspenseQuery>;
export type FetchEntityAiSuggestionsQueryResult = Apollo.QueryResult<FetchEntityAiSuggestionsQuery, FetchEntityAiSuggestionsQueryVariables>;
export const AcknowledgeAiSuggestionsDocument = gql`
    mutation AcknowledgeAISuggestions($input: [AcknowledgeAISuggestionInput!]!) {
  acknowledgeAISuggestions(input: $input) {
    id
    acceptanceStatus
  }
}
    `;
export type AcknowledgeAiSuggestionsMutationFn = Apollo.MutationFunction<AcknowledgeAiSuggestionsMutation, AcknowledgeAiSuggestionsMutationVariables>;

/**
 * __useAcknowledgeAiSuggestionsMutation__
 *
 * To run a mutation, you first call `useAcknowledgeAiSuggestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeAiSuggestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeAiSuggestionsMutation, { data, loading, error }] = useAcknowledgeAiSuggestionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcknowledgeAiSuggestionsMutation(baseOptions?: Apollo.MutationHookOptions<AcknowledgeAiSuggestionsMutation, AcknowledgeAiSuggestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcknowledgeAiSuggestionsMutation, AcknowledgeAiSuggestionsMutationVariables>(AcknowledgeAiSuggestionsDocument, options);
      }
export type AcknowledgeAiSuggestionsMutationHookResult = ReturnType<typeof useAcknowledgeAiSuggestionsMutation>;
export type AcknowledgeAiSuggestionsMutationResult = Apollo.MutationResult<AcknowledgeAiSuggestionsMutation>;
export type AcknowledgeAiSuggestionsMutationOptions = Apollo.BaseMutationOptions<AcknowledgeAiSuggestionsMutation, AcknowledgeAiSuggestionsMutationVariables>;